import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-executive-layout',
  templateUrl: './executive-layout.component.html',
  styleUrls: ['./executive-layout.component.scss']
})
export class ExecutiveLayoutComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
